import React, { useState } from "react";
import { Check } from "lucide-react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import FaqAccordion from "../components/site/FaqAccordion";
import FinalCTA from "../components/site/FinalCTA";
import { Dot } from "../components/site/Section";
import { PLANS, GROUP_PLAN, COMPARISON, PRICING_FAQS, CONTACT_EMAIL, registerUrl } from "../data/content";

const GROUP_MAIL = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("Barlo for my group of venues")}&body=${encodeURIComponent("Hi Barlo,\n\nWe run __ venues and would like a price for the group.\n\nName:\nPhone:\n")}`;

function Cell({ v }) {
  if (v === true) return <td className="c yes">Yes</td>;
  if (v === false) return <td className="c no">No</td>;
  return <td className="c">{v}</td>;
}

export default function Pricing() {
  const [billing, setBilling] = useState("monthly");
  const yearly = billing === "annual";

  return (
    <div className="App">
      <Navbar />
      <main>
        <section className="page-head" style={{ paddingBottom: 0 }}>
          <div className="wrap">
            <div className="pricing-head">
              <div>
                <h1>
                  <span className="label h1-kicker">Bar stock control software pricing</span>
                  One venue, one simple price<Dot />
                </h1>
                <p className="lede">Start with 14 days of everything in Pro, no card. Pick Starter or Pro when you pay.</p>
              </div>
              <div className="toggle" role="group" aria-label="Billing period" data-testid="pricing-billing-toggle">
                <button type="button" aria-pressed={!yearly} onClick={() => setBilling("monthly")} data-testid="pricing-billing-monthly">Monthly</button>
                <button type="button" aria-pressed={yearly} onClick={() => setBilling("annual")} data-testid="pricing-billing-annual">
                  Yearly <span className="save">Save 10%</span>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section style={{ paddingTop: 0 }} data-testid="pricing-section">
          <div className="wrap">
            <div className="plans plans-3">
              {PLANS.map((p) => (
                <article key={p.slug} className={`plan ${p.popular ? "pro" : ""}`} data-testid={`pricing-${p.slug}`}>
                  {p.popular && <span className="plan-badge">Most popular</span>}
                  <div>
                    <h2 className="plan-name">{p.name}</h2>
                    <p className="plan-for">{p.for}</p>
                  </div>
                  <div>
                    <div className="price">
                      <b>{yearly ? p.annual : p.monthly}</b>
                      <span>{yearly ? "a year per venue" : "a month per venue"}</span>
                    </div>
                    <p className="price-sub">{yearly ? p.annualPerMonth : p.weekly}</p>
                  </div>
                  <a className={`btn ${p.popular ? "btn-green" : "btn-ghost"}`} href={registerUrl(p.slug, billing)} data-testid={`pricing-${p.slug}-cta`}>
                    Start free trial
                  </a>
                  <p className="plan-staff">{p.staff}</p>
                  <ul>
                    {p.head && <li className="head">{p.head}</li>}
                    {p.features.map((f) => (
                      <li key={f}><Check size={18} strokeWidth={2.5} aria-hidden="true" /><span>{f}</span></li>
                    ))}
                  </ul>
                </article>
              ))}
              <article className="plan group" data-testid="pricing-group">
                <div>
                  <h2 className="plan-name">{GROUP_PLAN.name}</h2>
                  <p className="plan-for">{GROUP_PLAN.for}</p>
                </div>
                <div>
                  <div className="price"><b className="talk">{GROUP_PLAN.price}</b></div>
                  <p className="price-sub">{GROUP_PLAN.note}</p>
                </div>
                <a className="btn btn-ghost" href={GROUP_MAIL} data-testid="pricing-group-cta">{GROUP_PLAN.cta}</a>
                <p className="plan-staff">Staff logins agreed per venue</p>
                <ul>
                  {GROUP_PLAN.features.map((f) => (
                    <li key={f}><Check size={18} strokeWidth={2.5} aria-hidden="true" /><span>{f}</span></li>
                  ))}
                </ul>
              </article>
            </div>
            <div className="plans-foot">
              <span>Prices in GBP. Barlo is not VAT registered, so no VAT is added. Every plan starts with a 14-day free trial, no card needed. Secure payments by Stripe. Cancel any time.</span>
              <span>Starter covers up to 150 drinks products, enough for most pubs and bars. Archived products and drafts don't count. Need more? Pro has no limit, and moving up keeps everything you've set up.</span>
            </div>

            <div className="group-title"><h2>Compare the plans</h2></div>
            <div className="cmp-wrap" data-testid="pricing-plan-comparison">
              <table className="cmp">
                <thead><tr><th><span className="sr-only">Feature</span></th><th className="c">Starter</th><th className="c">Pro</th></tr></thead>
                <tbody>
                  {COMPARISON.map((g) => (
                    <React.Fragment key={g.group}>
                      <tr className="grp"><td colSpan={3}>{g.group}</td></tr>
                      {g.rows.map((r) => (
                        <tr key={r[0]}><td>{r[0]}</td><Cell v={r[1]} /><Cell v={r[2]} /></tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="faq-grid" style={{ marginTop: 80 }}>
              <div><h2>Before you start<Dot /></h2></div>
              <FaqAccordion items={PRICING_FAQS} testidPrefix="pricing-faq" />
            </div>
          </div>
        </section>
        <FinalCTA testidTrial="pricing-cta-trial" />
      </main>
      <Footer />
    </div>
  );
}
